export const projectsEn = [
    {
        id:"healthCloud",
        name: "Vicenna HealthCloud",
        technologies: 'C#, .Net 4.8, .Net Web APIs, Entity Framework, angularJs, SQL Server, Azure, Cosmos DB, Redis, Signal R',
        images: [
            {
                title:'Trip',
                src: "assets/images/voyages.webp",
            },
            {
                title:'Trip',
                src:"assets/images/voyage.webp",
            },
        ],
        url: "",
        detail:"Vicenna HealthCloud is a 360° enterprise solution for hospitals with integrated modules for Finance, Administration, Clinical, and Billing.",
        codeSourceUrl:'',
        detailIsDisplayed: false,
    },
    {
        id:"mautic",
        name: "Hospital Inventory Management System",
        technologies: 'C#, .Net 6, .Net Web APIs, Angular 13, SQL Server, Azure Cosmos Db',
        images: [
            {
                title:"Performance of an asset",
                src: "assets/images/asset-detail.jpg" 
            },
            
        ],
        url:'#portfolio',
        detail:"<p>Inventory Management and Point of Sale for hospital Pharmacies integrated with Vicenna HealthCloud.</p>",
        codeSourceUrl:'',
        detailIsDisplayed: false,
    },
    {
        id:"instED",
        name: "instED",
        technologies: 'Angular, Typescript, Javascript, HTML, CSS, Angular Material Design',
        images: [
            {
                title:'Pokedex',
                src:   "assets/images/pokedex2.png",
            }, 
        ],
        url:'#portfolio',
        detail:"<p>instED provides urgent medical care in the comfort of patient’s home.</p>",
        codeSourceUrl:'',
        detailIsDisplayed: false,
    },
    {
        id:"compAccelerator",
        name: "CompAccelerator",
        technologies: 'Angular, Typescript, Javascript, HTML, CSS, Angular Material Design',
        images: [
            {
                title:'Pokedex',
                src:   "assets/images/pokedex.png",
            }, 
        ],
        url:'#portfolio',
        detail:"<p>CompAccelerator is a highly configurable compensation solution designed from the HR perspective.</p>",
        codeSourceUrl:'',
        detailIsDisplayed: false,
    },
    {
        id:"portfolio",
        name: "portfolio",
        technologies: 'Angular 11, Typescript, Javascript, HTML, CSS, Angular Material Design',
        images: [
            {
                title:'Pokedex',
                src:   "assets/images/portfolio.PNG",
            }, 
        ],
        url:'#portfolio',
        detail:"<p>Personal porfolio developed in Angular 11 and deployed on firebase.</p>",
        codeSourceUrl:'',
        detailIsDisplayed: false,
    },
];

